@if (true) {
    <div class="notification-center-item__icon">
        <mat-icon class="{{ contextClass }}">{{ contextIcon }}</mat-icon>
    </div>
} @else {
    <div class="notification-center-item__pulsing-icon">
        <sphere-pulsing-indicator color="accent" animation="pulse" size="medium"></sphere-pulsing-indicator>
    </div>
}
<div [style.position]="'relative'">
    <div class="notification-center-item__read-indicator">
        <div
            class="read-indicator__wrapper"
            [matTooltip]="notification.read ? 'Mark as unread' : 'Mark as read'"
            matTooltipPosition="left"
            (click)="$event.stopPropagation(); setReadStatus.emit(!notification.read)"
        >
            @if (!notification.read) {
                <div class="read-indicator__circle"></div>
            }
        </div>
    </div>
    <section class="notification-center-item__title-wrapper">
        <div class="notification-center-item__title" [title]="notification.title">
            {{ notification.title }}
        </div>
        <div class="notification-center-item__timestamp text-subtle">
            @if (notification.app) {
                <small>{{ notification.app | uppercase }}</small
                ><span class="dot"></span>
            }
            <span [title]="formattedTimestamp">{{ fromNow }}</span>
        </div>
    </section>
    <section class="notification-center-item__body">
        <p class="notification-center-item__content" [title]="notification.content">
            {{ notification.content }}
        </p>
    </section>
    @if (isInProgress) {
        <section class="notification-center-item__progress">
            <mat-progress-bar mode="indeterminate" [style.height]="'1px !important'" color="accent"></mat-progress-bar>
        </section>
    }
</div>
